module.exports = __webpack_public_path__ + "img/Ireland.80193e28.png";